import React, { useState, useEffect } from 'react';
import { FaStar } from 'react-icons/fa';
import './style.scss';

const RatingStars = ({ initialValue = 0, onChange }) => {
  const [rating, setRating] = useState(initialValue);
  const [hover, setHover] = useState(null);

  // Update local state when initialValue changes
  useEffect(() => {
    setRating(initialValue);
  }, [initialValue]);

  const handleClick = (value) => {
    setRating(value);
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <div className="c-rating-stars" role="group" aria-label="Rating">
      {[...Array(5)].map((_, index) => {
        const value = index + 1;

        return (
          <button
            type="button"
            key={value}
            className={`c-rating-stars__button ${
              (hover || rating) >= value ? 'filled' : 'empty'
            }`}
            onClick={() => handleClick(value)}
            onMouseEnter={() => setHover(value)}
            onMouseLeave={() => setHover(null)}
            aria-label={`Rate ${value} out of 5 stars`}
            aria-pressed={rating === value}
          >
            <FaStar aria-hidden="true" />
          </button>
        );
      })}
    </div>
  );
};

export default RatingStars; 